import React from 'react';
import Skeleton from './Skeleton';

/**
 * ClientsSkeleton
 * Shimmer placeholder for the Clients / Residents directory:
 *   - header (title + controls)
 *   - responsive grid of client-card placeholders
 * Built from the base <Skeleton /> block (pure Tailwind shimmer).
 */

const CARD =
  'bg-white dark:bg-[#262b33] rounded-[20px] border border-[#E3E9F3] dark:border-gray-800 shadow-[0_1px_2px_rgba(15,23,42,0.05),0_4px_10px_-3px_rgba(15,23,42,0.06)]';

const S = Skeleton;

const CardSkeleton = () => (
  <div className={`${CARD} p-[18px]`}>
    <div className="flex items-center justify-between">
      <S className="h-5 w-20 rounded-[7px]" />
      <S className="h-4 w-16 rounded-md" />
    </div>
    <div className="border-t border-[#EEF2F8] dark:border-gray-800 my-[14px]" />
    <div className="flex items-center gap-[13px]">
      <S className="w-[50px] h-[50px] rounded-[15px] shrink-0" />
      <div className="flex-1 space-y-2">
        <S className="h-3.5 w-28 rounded-md" />
        <S className="h-3 w-20 rounded-md" />
      </div>
    </div>
    <S className="h-[54px] w-full rounded-xl mt-4" />
    <div className="flex items-center justify-between mt-[14px] pt-3 border-t border-dashed border-[#E3E9F3] dark:border-gray-800">
      <S className="h-3 w-24 rounded-md" />
      <S className="h-3 w-20 rounded-md" />
    </div>
  </div>
);

const ClientsSkeleton = () => (
  <div className="space-y-6 pb-8">
    {/* Header */}
    <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4">
      <div>
        <S className="h-7 w-40 rounded-xl" />
        <S className="h-3.5 w-56 rounded-md mt-3" />
      </div>
      <div className="flex gap-2.5">
        <S className="h-[42px] w-[240px] rounded-xl" />
        <S className="h-[42px] w-[150px] rounded-xl" />
        <S className="h-[42px] w-[130px] rounded-xl" />
      </div>
    </div>

    {/* Card grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)}
    </div>
  </div>
);

export default ClientsSkeleton;
